import React, {useEffect, useState} from 'react';

import './styles.scss';
import {Column, Row} from '../../layout';
import * as fonts from '../../../util/fonts';
import colors from '../../../util/colors';
import ModalTemplate from '../../modal';
import AppArrowButton from '../../app-arrow-button';
import Icon from '../../icon';
import {Icons} from '../../../util/icons';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {strings} from '../../../util/strings';

interface AppFilePreviewProps {
  file: any;
  name: string;
  onDelete(): void;
  files?: any[];
  deleteAll?: boolean;
  displayQuantity?: boolean;
  buStyles: any;
  labels: any;
  scope: string
}

function AppFilePreview({
  file,
  files,
  name,
  onDelete,
  buStyles,
  labels,
  deleteAll = false,
  displayQuantity = false,
  scope,
}: AppFilePreviewProps) {
  const [showModal, setShowModal] = useState(false);
  const [currentFile, setCurrentFile] = useState(file);
  const [currentIndex, setCurrentIndex] = useState(files?.indexOf(file) || 0);
  useEffect(() => {
    if (!!files) {
      setCurrentFile(files[currentIndex]);
    }
  }, [currentIndex]);

  useEffect(() => {
    setCurrentFile(file);
  }, [file]);

  const renderPageMarkers = () => {
    if (files) {
      return files.map((file, index) => (
        <Icon
          name={Icons.CIRCLE}
          width="7"
          height="7"
          color={index === currentIndex ? buStyles?.primaryColor : colors.lightGrey}
          changeViewbox={false}
          className="app-full-screen-page-marker"
        />
      ));
    }
  };

  const renderQuantity = () => {
    return files && files.length > 1
      ? `${files.length} ${labels?.createRefund?.createRefund_anexed_documents}`
      : file.path;
  };

  return (
    <Row
      className="app-file-preview-row justify-content-center"
      // onClick={() => setShowModal(true)}
      style={{background: 'linear-gradient(180deg, #F9F9F9 0%, #F0F0F0 100%)'}}>
      <Row className="clickable-input-row" onClick={() => setShowModal(true)}>
        {file.path.includes('pdf') ? (
          <object
            data={file.preview}
            type="application/pdf"
            className="app-file-preview-image"
          />
        ) : (
          <img
            src={file.preview}
            className="app-file-preview-image"
            onClick={() => setShowModal(true)}
          />
        )}
      </Row>
      <Column className="app-file-preview-text-column" style={{...fonts.SM}}>
        <div
          style={{
            ...fonts.Light,
            justifyContent: 'center',
            marginRight: '50px',
            textAlign: 'left',
          }}>
          {name}
        </div>
        <div
          style={{
            ...fonts.Medium,
            justifyContent: 'center',
            textAlign: 'left',
            overflowWrap: 'anywhere',
            marginRight: '30px',
            color: buStyles?.primaryColor || colors.blue,
          }}>
          {displayQuantity ? renderQuantity() : file.path}
        </div>
      </Column>
      <Column className="app-file-preview-close-column">
        <Icon
          onClick={() => {
            if (deleteAll) {
              setShowModal(false);
            }
            onDelete();
          }}
          className="app-file-preview-close-button delete-icon"
          name={Icons.CLOSE_CIRCLE}
          color={colors.black}
        />
      </Column>
      <ModalTemplate
        hideFooter={true}
        cross={true}
        show={showModal}
        onHide={() => {
          setShowModal(false);
        }}
        title={currentFile.name}
        subTitle={currentFile.path}
        size="xl">
        <Column className="app-full-screen-container">
          <Row className="app-full-screen-page-markers">
            {renderPageMarkers()}
          </Row>
          <Row className="app-full-screen-image-row">
            <AppArrowButton
              className="app-full-screen-arrow-left"
              color={buStyles?.primaryColor || colors.blue}
              direction="LEFT"
              onClick={() =>
                currentIndex > 0 && setCurrentIndex(currentIndex - 1)
              }
              disabled={currentIndex === 0}
            />

            {!currentFile.path.includes('pdf') ? (
              <img
                className="app-full-screen-image"
                src={currentFile.preview}
                alt=""
              />
            ) : (
              <object
                data={currentFile.preview}
                className="app-full-screen-image-pdf"></object>
            )}

            <AppArrowButton
              className="app-full-screen-arrow-right"
              color={buStyles?.primaryColor || colors.blue}
              direction="RIGHT"
              onClick={() =>
                files &&
                currentIndex < files?.length - 1 &&
                setCurrentIndex(currentIndex + 1)
              }
              disabled={files ? currentIndex === files.length - 1 : true}
            />
          </Row>
          <Row className="app-full-screen-delete-button-row">
            <Icon
              name={Icons.TRASH_BIN}
              width="18"
              height="21"
              color={buStyles?.primaryColor || colors.blue}
            />
            <div
              className="app-full-screen-delete-button"
              style={{
                ...fonts.ML,
                color: buStyles?.primaryColor || colors.blue,
              }}
              onClick={() => {
                // if (deleteAll) {
                //   setShowModal(false);
                // }
                setShowModal(false);
                onDelete();
              }}>
              {deleteAll && scope === 'createRefund'
                ? labels[scope].delete_all_documents
                : labels[scope].delete_document}
            </div>
          </Row>
        </Column>
      </ModalTemplate>
    </Row>
  );
}

const mapStateToProps = ({globalStyles, strings}: any) => ({
  buStyles: globalStyles.value,
  labels: strings.value.pt,
});

export default compose(connect(mapStateToProps)(AppFilePreview));
